import { render, staticRenderFns } from "./ReportsCard.vue?vue&type=template&id=5aa73e28&scoped=true"
import script from "./ReportsCard.vue?vue&type=script&lang=js"
export * from "./ReportsCard.vue?vue&type=script&lang=js"
import style0 from "./ReportsCard.vue?vue&type=style&index=0&id=5aa73e28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa73e28",
  null
  
)

export default component.exports